var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCousCous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6393D;}\n\t.st1{fill:#FDCC79;}\n\t.st2{fill:#EBBF71;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 99.13,
    cy: 81.85,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.96,84.2c-1.75,3.59-5.8,5.28-9.51,4.19c0.36,0.26,0.74,0.49,1.15,0.69c4,1.95,8.81,0.28,10.76-3.71 c1.95-4,0.28-8.81-3.71-10.76c-0.41-0.2-0.83-0.35-1.25-0.48C104.54,76.38,105.7,80.62,103.96,84.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 101.34,
    cy: 62.85,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.49,68.22c-3.99,0.11-7.37-2.7-8.12-6.48c-0.06,0.44-0.09,0.88-0.08,1.34c0.13,4.44,3.83,7.94,8.27,7.82 c4.44-0.13,7.94-3.83,7.82-8.27c-0.01-0.46-0.07-0.9-0.16-1.33C108.7,65.11,105.48,68.11,101.49,68.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 133.9,
    cy: 101.68,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.2,104.91c-2.4,3.19-6.7,4.08-10.13,2.3c0.3,0.32,0.63,0.63,1,0.9c3.55,2.67,8.6,1.96,11.27-1.59 c2.67-3.55,1.96-8.6-1.59-11.27c-0.36-0.27-0.75-0.5-1.14-0.71C140.26,97.34,140.6,101.73,138.2,104.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 104.98,
    cy: 106.13,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.42,108.98c-2.11-3.38-1.4-7.72,1.49-10.28c-0.41,0.17-0.81,0.36-1.2,0.61 c-3.77,2.36-4.92,7.32-2.56,11.09c2.36,3.77,7.32,4.92,11.09,2.56c0.39-0.24,0.74-0.52,1.07-0.81 C106.75,113.62,102.54,112.36,100.42,108.98z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 121.16,
    cy: 83.48,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.67,88.64c-3.83,1.12-7.81-0.74-9.49-4.22c0.05,0.44,0.13,0.88,0.26,1.32c1.25,4.27,5.72,6.71,9.98,5.47 c4.27-1.25,6.71-5.72,5.47-9.98c-0.13-0.44-0.3-0.85-0.49-1.25C128.85,83.81,126.5,87.52,122.67,88.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 139.56,
    cy: 81.66,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.58,86.94c-3.92,0.76-7.71-1.47-9.06-5.09c0.01,0.44,0.05,0.89,0.14,1.33c0.84,4.36,5.06,7.22,9.43,6.38 c4.36-0.84,7.22-5.06,6.38-9.43c-0.09-0.45-0.22-0.88-0.37-1.29C147.19,82.7,144.5,86.18,140.58,86.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 79.44,
    cy: 116.22,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.28,118.57c-1.75,3.59-5.8,5.28-9.51,4.19c0.36,0.26,0.74,0.49,1.15,0.69c4,1.95,8.81,0.28,10.76-3.71 c1.95-4,0.28-8.81-3.71-10.76c-0.41-0.2-0.83-0.35-1.25-0.48C84.86,110.74,86.02,114.98,84.28,118.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 71.21,
    cy: 88.23,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.36,93.61c-3.99,0.11-7.37-2.7-8.12-6.48c-0.06,0.44-0.09,0.88-0.08,1.34c0.13,4.44,3.83,7.94,8.27,7.82 c4.44-0.13,7.94-3.83,7.82-8.27c-0.01-0.46-0.07-0.9-0.16-1.33C78.56,90.5,75.35,93.49,71.36,93.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 124.4,
    cy: 135.15,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128.69,138.39c-2.4,3.19-6.7,4.08-10.13,2.3c0.3,0.32,0.63,0.63,1,0.9c3.55,2.67,8.6,1.96,11.27-1.59 c2.67-3.55,1.96-8.6-1.59-11.27c-0.36-0.27-0.75-0.5-1.14-0.71C130.76,130.82,131.09,135.2,128.69,138.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 88.19,
    cy: 146.48,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.64,149.33c-2.11-3.38-1.4-7.72,1.49-10.28c-0.41,0.17-0.81,0.36-1.2,0.61 c-3.77,2.36-4.92,7.32-2.56,11.09s7.32,4.92,11.09,2.56c0.39-0.24,0.74-0.52,1.07-0.81C89.96,153.97,85.75,152.71,83.64,149.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 104.37,
    cy: 123.83,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.88,128.99c-3.83,1.12-7.81-0.74-9.49-4.22c0.05,0.44,0.13,0.88,0.26,1.32 c1.25,4.27,5.72,6.71,9.98,5.47c4.27-1.25,6.71-5.72,5.47-9.98c-0.13-0.44-0.3-0.85-0.49-1.25 C112.07,124.16,109.71,127.87,105.88,128.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 146.24,
    cy: 120.29,
    r: 8.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.26,125.57c-3.92,0.76-7.71-1.47-9.06-5.09c0.01,0.44,0.05,0.89,0.14,1.33 c0.84,4.36,5.06,7.22,9.43,6.38c4.36-0.84,7.22-5.06,6.38-9.43c-0.09-0.45-0.22-0.88-0.37-1.29 C153.87,121.33,151.17,124.81,147.26,125.57z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCousCous);
export default __webpack_public_path__ + "static/media/Cous_cous.6444e74fbd573008deccb3430da71bed.svg";
export { ForwardRef as ReactComponent };